
export default {
  data () {
    return {}
  },
  computed: {
    // ---------------------------------------------------------//
    // Reseller id from sales system
    // ---------------------------------------------------------//
    resellerId () {
      const parsed = parseInt(process.env.VUE_APP_RESELLER_ID);
      if (isNaN(parsed)) { return -1; }
      return parsed
    },
    // ---------------------------------------------------------//
    // Base url for the api
    // ---------------------------------------------------------//
    baseUrl () {
      return process.env.VUE_APP_API_BASE_URL
    }
  }
}
